import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Study from "@/pages/Study";
import Complete from "@/pages/Complete";
import Admin from "@/pages/Admin";
import AdminUsers from "@/pages/AdminUsers";
import AdminTestHistory from "@/pages/AdminTestHistory";
import Test from "@/pages/Test";
import OfflineBanner from "@/components/OfflineBanner";
import AuthGate from "@/components/AuthGate";

function App() {
  return (
    <AuthGate>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/study/:categoryId" element={<Study />} />
          <Route path="/study/:categoryId/complete" element={<Complete />} />
          <Route path="/test/:categoryId" element={<Test />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/test-history" element={<AdminTestHistory />} />
        </Routes>
        <OfflineBanner />
      </BrowserRouter>
    </AuthGate>
  );
}

export default App;
